import { React } from 'react';
import logo from './CIERHA_Logo.png';
import './Nav.css';

function Nav() {
  return (
    <header className="cierha-navbar">
      <div className="cierha-navbar-inner">
        <a href="adminCIERHA" className="cierha-navbar-brand">
          <img src={logo} className="cierha-navbar-logo" alt="Logo CIERHA" />
          <span className="cierha-navbar-title">
            CIERHA - Chaire Interuniversitaire d&apos;Éthique et de Recherche Haïtiano-Africaines
          </span>
        </a>
        <nav>
          <ul className="cierha-navbar-links">
            <li><a href="#home">CONTACT</a></li>
            <li><a href="option">LOGIN</a></li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Nav;
